module.exports = __webpack_public_path__ + "static/media/lang_si_icon_0094bb_132.8bf69cbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/old/lang_si_icon_0094bb_132.png
// module id = 130
// module chunks = 0